import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { ApiResponse, System } from '../../data/system/system';

@Injectable()
export class SystemService extends System {

    constructor(private http: HttpClient) { super(); }

    //   getList(params: SystemParams): Observable<ApiResponse> {
    //     const host = `${env.host}${env.endpoint.system_get_list}`;
    //     return this.http.post<ApiResponse>(host, params).pipe(
    //       tap(data => {
    //         console.log(`system->getList->data`, data);
    //       })
    //     );
    //   }

    // save(param: SystemForm): Observable<ApiResponse> {
    //     const host = `${env.host}${env.endpoint.system_save}`;
    //     return this.http.post<ApiResponse>(host, param).pipe(
    //         tap(data => {
    //             console.log(`system->save->data`, data);
    //         })
    //     );
    // }

    update(param: any): Observable<ApiResponse> {
        const host = `${env.host}${env.endpoint.system_update}`;
        return this.http.put<ApiResponse>(host, param).pipe(
            tap(data => {
                console.log(`system->update->data`, data);
            })
        );
    }

    //   delete(id: number): Observable<ApiResponse> {
    //     const host = `${env.host}${env.endpoint.system_delete}/${id}`;
    //     return this.http.delete<ApiResponse>(host).pipe(
    //       tap(data => {
    //         console.log(`system->delete->data`, data);
    //       })
    //     );
    //   }

    //   getById(id: number): Observable<ApiResponse> {
    //     const host = `${env.host}${env.endpoint.system_get_by_id}/${id}`;
    //     return this.http.get<ApiResponse>(host).pipe(
    //       tap(data => {
    //         console.log(`system->getById->data`, data);
    //       })
    //     );
    //   }

} 